'use client';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { useCurrentLocale } from '@peerless/ui-locale';
import { useDebouncedCallback } from 'use-debounce';
import { competitorSearch } from '@peerless/data-access/next-api';
import { debounceTime, noResults } from './types';

export function useCompetitorSearch() {
  const { locale } = useCurrentLocale();
  const [keyword, setKeyword] = useState('');

  const { data, isLoading } = useQuery({
    queryKey: ['Competitor', 'Search', locale, keyword],
    queryFn: context =>
      competitorSearch(
        { locale, keyword },
        {
          signal: context.signal,
        }
      ),
    enabled: !!keyword,
  });

  const search = useDebouncedCallback((keyword: string) => {
    setKeyword(keyword);
  }, debounceTime);

  const reset = useCallback(() => {
    setKeyword('');
  }, [setKeyword]);

  return {
    data: data ?? noResults(keyword),
    isLoading,
    search,
    reset,
  };
}
